module.exports = __webpack_public_path__ + "assets/img/mainItem04.9df6c316.svg";